import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "value", "onChange", "RadioGroupProps", "label", "FormLabelProps", "helperText", "FormHelperTextProps", "children"];
import { FormControl, FormHelperText as FormHelperTextMui, FormLabel as FormLabelMui, RadioGroup } from '@material-ui/core';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { ColorDynamic } from "../theme/Color.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FormLabel = /*#__PURE__*/styled(FormLabelMui).withConfig({
  displayName: "RadioGroupField__FormLabel",
  componentId: "SD__sc-1udxviq-0"
})(["margin-bottom:8px;color:", ";font-weight:600;"], ColorDynamic.Dark300);
var FormHelperText = /*#__PURE__*/styled(FormHelperTextMui).withConfig({
  displayName: "RadioGroupField__FormHelperText",
  componentId: "SD__sc-1udxviq-1"
})(["margin-top:8px;color:", ";&.Mui-error{color:", ";}"], ColorDynamic.Dark300, ColorDynamic.Red500);
export var RadioGroupField = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      name,
      value = '',
      onChange,
      RadioGroupProps: radioGroupProps,
      label,
      FormLabelProps: formLabelProps,
      helperText,
      FormHelperTextProps: formHelperTextProps,
      children
    } = _ref,
    formControlProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(FormControl, _objectSpread(_objectSpread({}, formControlProps), {}, {
    hiddenLabel: !label,
    children: [!!label && /*#__PURE__*/_jsx(FormLabel, _objectSpread(_objectSpread({}, formLabelProps), {}, {
      children: label
    })), /*#__PURE__*/_jsx(RadioGroup, _objectSpread(_objectSpread({
      ref: ref
    }, radioGroupProps), {}, {
      name: name,
      value: value,
      onChange: onChange,
      children: children
    })), !!helperText && /*#__PURE__*/_jsx(FormHelperText, _objectSpread(_objectSpread({}, formHelperTextProps), {}, {
      children: helperText
    }))]
  }));
});
if (process.env.NODE_ENV !== "production") RadioGroupField.displayName = "RadioGroupField";